import React, { useState } from "react";
import { Link } from "react-scroll";
import AiChatBar from "./AiChatBar";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";

const Header = ({ setDarkMode }) => {
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious();
    if (latest > previous && latest > 150) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  });

  return (
    <div className="w-full relative ">
      <motion.nav
        className=" fixed w-full transition z-30  md:px-5 py-2 text-black"
        variants={{
          visible: { y: 0 },
          hidden: { y: "-100%" },
        }}
        animate={hidden ? "hidden" : "visible"}
        transition={{ duration: 0.15, ease: [0.61, 1, 0.88, 1] }}
      >
        <div className="flex items-center justify-between relative z-30 dark:text-white">
          <h2 className="font-iDroid lg:text-3xl my-2 ml-2 p-2 justify-start">
            <span className="text-coustomGreen">D</span>
            <span className="text-pink-400">S</span>
          </h2>
          <div className="px-4 py-2 flex items-center lg:gap-8 justify-center lg:text-lg bg-black/10 dark:bg-white/10 backdrop-filter backdrop-blur-sm rounded-full">
            <Link
              className="px-2 cursor-pointer"
              to="about"
              smooth={true}
              offset={30}
              duration={500}
            >
              About
            </Link>
            <Link
              className="px-2 cursor-pointer"
              to="projects"
              smooth={true}
              offset={-45}
              duration={900}
            >
              Project
            </Link>
            <Link
              className="px-2 cursor-pointer"
              to="contact"
              smooth={true}
              offset={30}
              duration={1000}
            >
              Contact
            </Link>
          </div>
          <div className="flex items-center text-sm lg:text-lg gap-2 justify-center mr-2">
            <button
              className="px-4 py-2 cursor-pointer  bg-black/10 dark:bg-white/10 backdrop-filter backdrop-blur-sm rounded-full"
              onClick={() => setDarkMode((prev) => !prev)}
            >
              <span className="hidden dark:block">Light</span>
              <span className=" dark:hidden">Dark</span>
            </button>
          </div>
        </div>
      </motion.nav>
      <AiChatBar />
    </div>
  );
};

export default Header;
